module.exports = __webpack_public_path__ + "media/components/footer/static/snow__white-135a0d685367fdc1aecdae5a5cb12fff.svg";